import { json3n35pf5np6si4 as json } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/json.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__plus_impl_yu9v8fuwslfu377uhg as Duration__plus_impl_yu9v8f,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Monotonic_instancewn07e60bp6rj as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs31ikzp5dku7pk as ValueTimeMark__elapsedNow_impl_eonqvs,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/TimeSource.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function subObj($this, $receiver, key) {
  var tmp = $receiver[key];
  var tmp0_elvis_lhs = (!(tmp == null) ? !(tmp == null) : false) ? tmp : null;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    var obj = json([]);
    $receiver[key] = obj;
    tmp_0 = obj;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function jsonForEach($this, obj, action) {
  return function () {
    for (var key in obj) {
      action(key, obj[key]);
    }
    return void 3;
  }();
}
function DynamicCss$customStyleSheetElement$delegate$lambda() {
  var tmp = document.createElement('style');
  var sheet = tmp instanceof HTMLStyleElement ? tmp : THROW_CCE();
  sheet.title = 'generated-css';
  ensureNotNull(document.head).appendChild(sheet);
  return sheet;
}
function DynamicCss$_get_customStyleSheetElement_$ref_s5nun7() {
  return constructCallableReference((p0) => p0.get_customStyleSheetElement_tvmc4n_k$(), 1, 0, 133);
}
function DynamicCss$_get_customStyleSheet_$ref_cvbo9x() {
  return constructCallableReference((p0) => p0.get_customStyleSheet_5inpet_k$(), 1, 0, 134);
}
var DynamicCssClass;
function DynamicCss() {
  if (DynamicCssClass === VOID) {
    class $ {
      constructor(basePath) {
        this.basePath_1 = basePath;
        var tmp = this;
        tmp.customStyleSheetElement$delegate_1 = lazy(DynamicCss$customStyleSheetElement$delegate$lambda);
        var tmp_0 = this;
        tmp_0.customStyleSheet$delegate_1 = lazy(() => {
          this.get_customStyleSheetElement_tvmc4n_k$();
          // Inline function 'kotlin.let' call
          var tmp0 = document.styleSheets;
          var tmp$ret$1;
          $l$block: {
            var inductionVariable = 0;
            var last = tmp0.length;
            if (inductionVariable < last)
              do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'org.w3c.dom.css.get' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$2 = tmp0[i];
                var copy = ensureNotNull(tmp$ret$2);
                if (copy.title === this.get_customStyleSheetElement_tvmc4n_k$().title) {
                  tmp$ret$1 = copy instanceof CSSStyleSheet ? copy : THROW_CCE();
                  break $l$block;
                }
              }
               while (inductionVariable < last);
            throw IllegalStateException().new_kotlin_IllegalStateException_1wtnp1_k$();
          }
          return tmp$ret$1;
        });
        this.fontHandled_1 = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
        this.queue_1 = json([]);
        var tmp_1 = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance();
        tmp_1.flushTotal_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
        this.ruleTotal_1 = 0;
      }
      get_customStyleSheetElement_tvmc4n_k$() {
        var tmp0 = this.customStyleSheetElement$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('customStyleSheetElement', 1, tmp, DynamicCss$_get_customStyleSheetElement_$ref_s5nun7(), null);
        return tmp0.get_value_j01efc_k$();
      }
      get_customStyleSheet_5inpet_k$() {
        var tmp0 = this.customStyleSheet$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('customStyleSheet', 1, tmp, DynamicCss$_get_customStyleSheet_$ref_cvbo9x(), null);
        return tmp0.get_value_j01efc_k$();
      }
      font_p6doqv_k$(font) {
        if (!this.fontHandled_1.add_utx5q5_k$(font.cssFontFamilyName_1))
          return font.cssFontFamilyName_1;
        if (!(font.url_1 == null)) {
          var tmp = ensureNotNull(document.head);
          var tmp_0 = document.createElement('link');
          // Inline function 'kotlin.apply' call
          var this_0 = tmp_0 instanceof HTMLLinkElement ? tmp_0 : THROW_CCE();
          this_0.rel = 'stylesheet';
          this_0.type = 'text/css';
          this_0.href = font.url_1;
          tmp.appendChild(this_0);
        }
        if (!(font.direct_1 == null)) {
          // Inline function 'kotlin.collections.forEach' call
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s = font.direct_1.normal_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            this.rule$default_4ip9wm_k$("@font-face {font-family: '" + font.cssFontFamilyName_1 + "';font-style: normal;font-weight: " + element.get_key_18j28a_k$() + ";src:url('" + (this.basePath_1 + element.get_value_j01efc_k$()) + "');}");
          }
          // Inline function 'kotlin.collections.forEach' call
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_0 = font.direct_1.italics_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
            this.rule$default_4ip9wm_k$("@font-face {font-family: '" + font.cssFontFamilyName_1 + "';font-style: italic;font-weight: " + element_0.get_key_18j28a_k$() + ";src:url('" + (this.basePath_1 + element_0.get_value_j01efc_k$()) + "');}");
          }
        }
        return font.cssFontFamilyName_1;
      }
      rule_nw06my_k$(rule, index) {
        try {
          return this.get_customStyleSheet_5inpet_k$().insertRule(rule, index);
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            throw Exception().new_kotlin_Exception_9qyiel_k$('Failed to add rule ' + rule, e);
          } else {
            throw $p;
          }
        }
      }
      rule$default_4ip9wm_k$(rule, index, $super) {
        index = index === VOID ? 0 : index;
        return $super === VOID ? this.rule_nw06my_k$(rule, index) : $super.rule_nw06my_k$.call(this, rule, index);
      }
      add_nb48up_k$(selector, key, value, media) {
        subObj(this, subObj(this, this.queue_1, media), selector)[key] = value;
      }
      flush_shahbo_k$() {
        // Inline function 'kotlin.time.measureTime' call
        // Inline function 'kotlin.time.measureTime' call
        var mark = Monotonic_instance.markNow_ns2ype_k$();
        var tmp = this.queue_1;
        jsonForEach(this, tmp, (media, it) => {
          // Inline function 'kotlin.text.isNotBlank' call
          var wrapInMedia = !isBlank(media);
          if (wrapInMedia) {
            var str = StringBuilder().new_kotlin_text_StringBuilder_7at1nh_k$('@media ' + media + ' {');
            var tmp = (!(it == null) ? !(it == null) : false) ? it : THROW_CCE();
            jsonForEach(this, tmp, (selector, it) => {
              str.append_22ad7x_k$(selector);
              str.append_22ad7x_k$('{');
              var tmp = (!(it == null) ? !(it == null) : false) ? it : THROW_CCE();
              jsonForEach(this, tmp, (key, value) => {
                str.append_22ad7x_k$(key);
                str.append_22ad7x_k$(':');
                str.append_t8pm91_k$(value);
                str.append_22ad7x_k$(';');
                return Unit_instance;
              });
              str.append_22ad7x_k$('}');
              this.ruleTotal_1 = this.ruleTotal_1 + 1 | 0;
              return Unit_instance;
            });
            str.append_22ad7x_k$('}');
            this.rule_nw06my_k$(str.toString(), 0);
          } else {
            var tmp_0 = (!(it == null) ? !(it == null) : false) ? it : THROW_CCE();
            jsonForEach(this, tmp_0, (selector, it) => {
              var str = StringBuilder().new_kotlin_text_StringBuilder_7at1nh_k$(selector);
              str.append_22ad7x_k$('{');
              var tmp = (!(it == null) ? !(it == null) : false) ? it : THROW_CCE();
              jsonForEach(this, tmp, (key, value) => {
                str.append_22ad7x_k$(key);
                str.append_22ad7x_k$(':');
                str.append_t8pm91_k$(value);
                str.append_22ad7x_k$(';');
                return Unit_instance;
              });
              str.append_22ad7x_k$('}');
              this.ruleTotal_1 = this.ruleTotal_1 + 1 | 0;
              this.rule_nw06my_k$(str.toString(), 0);
              return Unit_instance;
            });
          }
          return Unit_instance;
        });
        this.queue_1 = json([]);
        var tmp$ret$0 = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
        // Inline function 'kotlin.also' call
        var this_0 = new (Duration())(tmp$ret$0);
        var it = this_0.rawValue_1;
        this.flushTotal_1 = Duration__plus_impl_yu9v8f(this.flushTotal_1, it);
        this_0.rawValue_1;
      }
    }
    initMetadataForClass($, 'DynamicCss');
    DynamicCssClass = $;
  }
  return DynamicCssClass;
}
//region block: exports
export {
  DynamicCss as DynamicCssr3610hzbsxx2,
};
//endregion

//# sourceMappingURL=DynamicCss.js.mjs.map
